import { testimonials as mockTestimonials, type Testimonial } from '../mocks/testimonials';
import { STORAGE_KEYS, readStoredJSON, writeStoredJSON } from './state/appState';

const MAX_HOME_TESTIMONIALS = 20;

function isLegacyDemoTestimonial(item: Testimonial) {
  const matchingDemo = mockTestimonials.find((demoItem) => demoItem.id === item.id);
  if (!matchingDemo) {
    return false;
  }

  return (
    matchingDemo.organization === item.organization &&
    matchingDemo.orgFullName === item.orgFullName &&
    matchingDemo.quote === item.quote &&
    matchingDemo.name === item.name &&
    matchingDemo.title === item.title &&
    matchingDemo.year === item.year
  );
}

export function normalizeStoredTestimonials(items: Testimonial[]) {
  let defaultHomeSelections = 0;

  return items
    .filter((item) => !isLegacyDemoTestimonial(item))
    .map((item) => {
      const isActive = item.active !== false;
      const hasExplicitHomeFlag = typeof item.showOnHome === 'boolean';
      const showOnHome = isActive
        ? (
            hasExplicitHomeFlag
              ? item.showOnHome
              : defaultHomeSelections < MAX_HOME_TESTIMONIALS
          )
        : false;

      if (!hasExplicitHomeFlag && showOnHome) {
        defaultHomeSelections += 1;
      }

      return {
        ...item,
        active: isActive,
        showOnHome,
      };
    });
}

export function sanitizeStoredTestimonials(items: Testimonial[]) {
  return normalizeStoredTestimonials(items);
}

export function loadStoredTestimonials() {
  return normalizeStoredTestimonials(readStoredJSON<Testimonial[]>(STORAGE_KEYS.testimonials, []));
}

export function saveStoredTestimonials(items: Testimonial[]) {
  writeStoredJSON(STORAGE_KEYS.testimonials, normalizeStoredTestimonials(items));
}

export function countHomeFeaturedTestimonials(items: Testimonial[]) {
  return normalizeStoredTestimonials(items).filter((item) => item.active && item.showOnHome).length;
}

export function sanitizeLegacyTestimonialsInStorage() {
  if (typeof window === 'undefined') {
    return false;
  }

  const storedRaw = readStoredJSON<Testimonial[]>(STORAGE_KEYS.testimonials, []);
  const sanitized = normalizeStoredTestimonials(storedRaw);
  const nextPayload = JSON.stringify(sanitized);

  if (window.localStorage.getItem(STORAGE_KEYS.testimonials) === nextPayload) {
    return false;
  }

  window.localStorage.setItem(STORAGE_KEYS.testimonials, nextPayload);
  return true;
}
